import { ReactNode } from "react";
import { formatRatioAsPercentage } from "utils/formatting";
import { percentagePointDifference } from "utils/mathFormulas/mathFormulas.helper";

export const prepareAnnualCashFlowOutcomesData = (
    referencePlan: CarbonReductionPlan,
    comparedPlan: CarbonReductionPlan,
    referencePlanName: string,
    comparedPlanName: string
) => {
    // BarChart Data
    const chartData = referencePlan.annualSummaries
        .map((annualSummary) => {
            const totalIncentives = annualSummary.incentives;
            const annualUtilitySavings = annualSummary.annualUtilityCostSavings;
            const annualCarbonPolicyCostSavings = annualSummary.carbonPolicySavings;
            const revenue = annualSummary.revenue;
            const annualCapex = -annualSummary.totalMeasureCost;

            return {
                totalIncentives,
                annualUtilitySavings,
                annualCarbonPolicyCostSavings,
                revenue,
                annualCapex,
                year: annualSummary.year,
                netIncrementalCost: 0,
                cashFlowAnnual:
                    totalIncentives + annualUtilitySavings + annualCarbonPolicyCostSavings + revenue + annualCapex,
                totalIncrementalCost: referencePlan.splitPlanLifetimeIncrementalMeasureCosts,
            };
        })
        .sort((a, b) => a.year - b.year);

    // Total data
    const incrementalRoiReference = referencePlan.planLifetimeIncrementalRoi;
    const incrementalRoiCompared = comparedPlan.planLifetimeIncrementalRoi;
    const roiEvolution = percentagePointDifference(incrementalRoiCompared, incrementalRoiReference);

    // Tooltip
    const tooltipElement: ReactNode = (
        <>
            {comparedPlanName} ROI is {formatRatioAsPercentage(incrementalRoiCompared)}%
            <br />
            <br />
            {referencePlanName} ROI is {formatRatioAsPercentage(incrementalRoiReference)}%
            <br />
            <br />
            There is a {formatRatioAsPercentage(roiEvolution)} percentage points difference between the two plans
        </>
    );

    return {
        incrementalRoiReference,
        roiEvolution,
        chartData,
        tooltipElement,
    };
};

export interface CashFlowData {
    year?: number;
    calendarYear?: number;
    cashFlowCumulative: number;
    [key: string]: any;
}

export const cashFlowTableOutcomesColumns: (keyof OutcomesAnnualCashFlowChartDatum)[] = [
    "year",
    "annualUtilitySavings",
    "annualCapex",
    "totalIncentives",
    "cashFlowAnnual",
    "revenue",
    "annualCarbonPolicyCostSavings",
];

export const cashFlowChartBarOutcomesKeys: (keyof OutcomesAnnualCashFlowChartDatum)[] = [
    "annualCapex",
    "totalIncentives",
    "annualUtilitySavings",
    "annualCarbonPolicyCostSavings",
    "revenue",
];
